import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  DynamicForm,
  CreateDynamicFormRequest,
  UpdateDynamicFormRequest,
  SyncFieldsRequest,
  DynamicFormsListParams
} from '../types';

const { DYNAMIC_FORMS } = API_ENDPOINTS;

export const dynamicFormsApi = {
  getAll: (params?: DynamicFormsListParams) =>
    apiClient.getPaginated<DynamicForm>(DYNAMIC_FORMS.LIST, params),

  getById: (id: number, options?: { scope?: 'all' }) =>
    apiClient.get<DynamicForm>(
      DYNAMIC_FORMS.GET(id),
      options?.scope ? { scope: options.scope } : undefined
    ),

  create: (data: CreateDynamicFormRequest) =>
    apiClient.post<DynamicForm>(DYNAMIC_FORMS.CREATE, data),

  update: (id: number, data: UpdateDynamicFormRequest) =>
    apiClient.put<DynamicForm>(DYNAMIC_FORMS.UPDATE(id), data),

  delete: (id: number) => apiClient.delete(DYNAMIC_FORMS.DELETE(id)),

  syncFields: (id: number, data: SyncFieldsRequest) =>
    apiClient.put<DynamicForm>(DYNAMIC_FORMS.SYNC_FIELDS(id), data),

  activate: (id: number) =>
    apiClient.post<DynamicForm>(DYNAMIC_FORMS.ACTIVATE(id)),

  deactivate: (id: number) =>
    apiClient.post<DynamicForm>(DYNAMIC_FORMS.DEACTIVATE(id)),

  setDefault: (id: number) =>
    apiClient.post<DynamicForm>(DYNAMIC_FORMS.SET_DEFAULT(id)),

  unsetDefault: (id: number) =>
    apiClient.post<DynamicForm>(DYNAMIC_FORMS.UNSET_DEFAULT(id)),

  duplicate: (id: number) =>
    apiClient.post<DynamicForm>(DYNAMIC_FORMS.DUPLICATE(id)),

  getActiveByType: (type: string, options?: { scope?: 'all' }) =>
    apiClient.get<DynamicForm>(
      DYNAMIC_FORMS.ACTIVE_BY_TYPE(type),
      options?.scope ? { scope: options.scope } : undefined
    )
};
